import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, MenuController, AlertController } from 'ionic-angular';

//import { HomePage } from '../home/home';

import { AuthServiceProvider } from '../../providers/auth-service/auth-service';
import { AuthProvider } from '../../providers/auth/auth';
import { Storage } from '@ionic/storage';
/**
 * Generated class for the LoginPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-login',
  templateUrl: 'login.html',
})
export class LoginPage {
	responseData : any;
  userData = {"email": "","password": ""};

    loading: any;

  constructor(public alertCtrl: AlertController, public navCtrl: NavController, public navParams: NavParams, public authServiceProvider:AuthServiceProvider, private storage: Storage, public authService: AuthProvider, public loadingCtrl: LoadingController, public menu : MenuController,) {
  }

ionViewDidLoad() {
 
        this.showLoader();
 
        //Check if already authenticated
        this.authService.checkAuthentication().then((res) => {
            console.log("Already authorized");
            this.loading.dismiss();
            this.navCtrl.setRoot('OrdersPage');
        }, (err) => {
            console.log("Not already authorized");
            this.loading.dismiss();
        });
 
    }
 
    login(){
 
        this.showLoader();
        
        let credentials = this.userData;

        // let credentials = {
        //     email: this.email,
        //     password: this.password
        // };
 
        this.authService.login(credentials).then((result) => {
            this.loading.dismiss();
            console.log("LOGIN RESULT: ", result);
            
            this.menu.enable(true);
            this.navCtrl.setRoot('HomePage');
        }, (err) => {
            this.loading.dismiss();
            let alert = this.alertCtrl.create({
                                    message: err.json().error,
                                    //duration: 2000,
                                    //position: 'bottom'
                                  });
            alert.present();
            console.log(err);
        });
 
    }
 
    launchSignup(){
        this.navCtrl.push('SignupPage');
    }
 
    showLoader(){
 
        this.loading = this.loadingCtrl.create({
            content: 'Authenticating...'
        });
 
        this.loading.present();
 
    }
 


  login_old(){

  	this.authServiceProvider.postData(this.userData,'login').then((result) => {
      this.responseData = result;

      if(this.responseData.data.api_token){
      this.storage.set('token', this.responseData.data.api_token);
      localStorage.setItem('userData', JSON.stringify(this.responseData.data.userData));

      localStorage.setItem('token', this.responseData.data.api_token);
      //localStorage.setItem('token', 'FAKE TOKEN FOR DEBUG');
      
      this.navCtrl.push('CreateOrderPage');
      }
      else{ console.log("User already exists"); }
    }, (err) => {
      // Error log
    });
    // Your app login API web service call triggers 
    //this.navCtrl.push(HomePage, {}, {animate: false});
  }

}



// WEBPACK FOOTER //
// ./src/pages/login/login.ts